<template>
	<!--
	<div class="menu ">
		<div class="menu-profile bg-black-300">
			<div class="">
				<div class="d-flex flex-row">
					<div v-if="user.avatar">
						<img onerror="javascript:this.src='/images/avatar/user.png'" class="menu-profile-image-square"
							:src="`/images/avatar/${user.avatar}`" alt="" />
					</div>
					<div class="mt-2 ms-2 fs-15px">
						{{ user.name }}
					</div>
				</div>
				<div class="d-flex flex-row">
					<div class="mt-1">
						<b>Баланс: {{ user.balance || 0 }} <i class="far fa-heart p-l-5 p-t-5"></i></b>
					</div>
				<a class="btn btn-primary btn-xs ms-2">Купить</a>
	</div>
	</div>
	</div>
	</div>-->


	<div class="menu">
		<div class="menu-profile" v-bind:class="{ 'active': this.stat == 'expand' }">
			<a href="javascript:;" class="menu-profile-link" v-on:click="expand()">
				<div class=" with-shadow"></div>
				<div class="menu-profile-image w-50px h-50px">
					<div v-if="user.avatar">
						<img onerror="javascript:this.src='/images/avatar/user.png'"
							:src="`/images/avatar/${user.avatar}`" alt="" width="50" height="50" class="user-avatar">
					</div>
				</div>
				<div class="menu-profile-info">
					<div class="d-flex align-items-center">
						<div class="flex-grow-1">
							{{ user.name }}
						</div>
						<div class="menu-caret ms-auto"></div>
					</div>
					<div class="d-flex flex-row justify-content-start align-items-center">
						<div>Рейтинг: </div> &nbsp;
						<Rating :score="user.rating" />
					</div>
					<div class="d-flex flex-row justify-content-start align-items-end">
						<div>Баланс: {{ user.balance || 0 }}</div>
						<div class="fs-10px fw-normal ps-1">руб.</div>
					</div>
				</div>
			</a>
		</div>
		<div id="appSidebarProfileMenu" class="collapse"
			v-bind:class="{ 'd-block': this.stat == 'expand' && !this.appOptions.pageSidebarMinified, 'd-none': this.stat == 'collapse' }">
			<div class="menu-item pt-5px cursor-pointer">
				<a @click="$router.push('/mypage').catch(() => { });" class="menu-link">
					<div class="menu-icon"><i class="fa fa-cog"></i></div>
					<div class="menu-text">Моя страница</div>
				</a>
			</div>
			<div class="menu-item pb-5px cursor-pointer">
				<a @click="$router.push('/rating').catch(() => { });" class="menu-link">
					<div class="menu-icon"><i class="fa fa-star"></i></div>
					<div class="menu-text">Рейтинг</div>
				</a>
			</div>
      <!--
			<div class="menu-item pb-5px">
				<a href="javascript:;" class="menu-link">
					<div class="menu-icon"><i class="fa fa-question-circle"></i></div>
					<div class="menu-text">Баланс</div>
				</a>
			</div> -->
			<div class="menu-item pb-5px cursor-pointer">
				<a @click="$router.push('/profile').catch(() => { });" class="menu-link">
					<div class="menu-icon"><i class="fas  fa-user-gear"></i></div>
					<div class="menu-text">Редактировать</div>
				</a>
			</div>
			<div class="menu-item pb-5px cursor-pointer">
				<a @click="$router.push('/password').catch(() => { });" class="menu-link">
					<div class="menu-icon"><i class="fas  fa-star-of-life"></i></div>
					<div class="menu-text">Сменить пароль</div>
				</a>
			</div>
			<div class="menu-item pb-5px cursor-pointer">
				<a @click="$router.push('/logout').catch(() => { });" class="menu-link">
					<div class="menu-icon"><i class="fas fa-sign-out-alt "></i></div>
					<div class="menu-text">Выйти</div>
				</a>
			</div>
			<div class="menu-divider m-0"></div>
		</div>
	</div>


</template>

<script>
import AppOptions from '../../config/AppOptions.vue'

export default {
	name: 'SidebarNavProfile',
	data() {
		return {
			stat: '',
			appOptions: AppOptions,
			user: { avatar: null }
		}
	},
	created() {
		if (localStorage.user) {
			this.user = JSON.parse(localStorage.getItem('user'))
		}
		window.eventBus.$on('user.update', resp => {
			this.user = resp
		})

	},
	methods: {
		expand: function () {
			this.stat = (this.stat == 'expand') ? 'collapse' : 'expand'
		}
	}
}
</script>


<style>
.menu-profile-image-square {
	width: 50px;
	height: 50px;
	margin-bottom: 12px;
	border-radius: 50px;
}
</style>